import { bannerHeaderModuleDescriptionLenses } from 'root/src/client/logic/header/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewOneRow } = bannerHeaderModuleDescriptionLenses

export default (state, { moduleId }) => viewOneRow(
	moduleId, moduleDescriptions,
)
